import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import flagEN from '../../assets/img/gb.svg';
import flagFR from '../../assets/img/fr.svg';
import DropdownIndicator from '../common/dropdownIndicator';
import './languageSwitcher.scss';

function LanguageSwitcher() {
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();

    const options = [
        { value: 'en', label: 'EN', flag: flagEN },
        { value: 'fr', label: 'FR', flag: flagFR }
    ];

    const formatOptionLabel = ({ label, flag }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
                src={flag}
                alt={label}
                style={{ marginRight: '8px', height: '16px', width: '24px' }}
            />
            <span>{label}</span>
        </div>
    );

    const changeLanguage = (option) => {
        const languageCode = option.value;
        i18n.changeLanguage(languageCode);

        const pathWithoutLang = location.pathname.split('/').slice(2).join('/');
        const newLocalizedPath = `/${languageCode}/${pathWithoutLang}${location.search}`;
        navigate(newLocalizedPath, { replace: true });
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            background: 'transparent',
            border: 0,
            boxShadow: 0,
            cursor: 'pointer',
            minHeight: 'auto'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: 0
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#fff',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '17px',
            width: '51px'
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            color: state.isSelected ? '#00AF60' : '#0A100D',
            cursor: 'pointer',
            '&:hover': {
                ...provided['&:hover'],
                color: '#00AF60',
                backgroundColor: 'transparent'
            }
        })
    };

    return (
        <Select
            value={options.find((o) => o.value === i18n.language)}
            onChange={changeLanguage}
            options={options}
            styles={customStyles}
            formatOptionLabel={formatOptionLabel}
            isSearchable={false}
            components={{ DropdownIndicator }}
            className="language-switcher"
        />
    );
}

export default LanguageSwitcher;
